import * as React from "react";
import { fetchMaintenanceBanner } from "../../../../apis";

import "./style.scss";

interface MaintenanceBannerState {
  enabled: boolean;
  message: string;
}

class MaintenanceBanner extends React.Component<{}, MaintenanceBannerState> {
  refreshTimer: number;

  state = {
    enabled: false,
    message: ""
  };

  componentDidMount() {
    this.refresh();
    this.refreshTimer = window.setInterval(this.refresh, 60 * 1000);
  }

  componentWillUnmount() {
    window.clearInterval(this.refreshTimer);
  }

  refresh = () => {
    fetchMaintenanceBanner()
      .then((banner: MaintenanceBannerState) => {
        this.setState({
          enabled: banner.enabled,
          message: banner.message || ""
        });
      })
      .catch(() => {
        // Keep the last successfully loaded state if a refresh fails.
      });
  };

  render() {
    const { enabled, message } = this.state;

    if (!enabled || !message) {
      return null;
    }

    return (
      <div className="maintenance-banner" role="status">
        <span className="maintenance-banner__icon" aria-hidden="true">
          !
        </span>
        <span>{message}</span>
      </div>
    );
  }
}

export default MaintenanceBanner;



// WEBPACK FOOTER //
// ./client/modules/common/components/MaintenanceBanner/component.tsx